import "./PluginHeader.css"

export default function PluginHeader() {
  return (
    <div className="header">
      <img src="/header-logo1.png" alt="logo" className="logo" />
    </div>
  );
}